(function() {
  const STORAGE_KEY = 'shopify_wishlist';

  function getWishlist() {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
    window.dispatchEvent(new CustomEvent('wishlist:changed', { detail: { wishlist: list } }));
  }

  function showToast(msg) {
    const toast = document.getElementById('wishlist-toast');
    const toastMsg = document.getElementById('wishlist-toast-msg');
    if (!toast || !toastMsg) return;
    toastMsg.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toast._timeout);
    toast._timeout = setTimeout(() => {
      toast.classList.remove('show');
    }, 2400);
  }

  function toggleWishlist(handle) {
    if (!handle) return;
    let list = getWishlist();
    let isAdded = false;
    if (list.includes(handle)) {
      list = list.filter(h => h !== handle);
      showToast('Removed from wishlist');
    } else {
      list.push(handle);
      isAdded = true;
      showToast('Added to wishlist');
    }
    saveWishlist(list);
    updateAll();
    return isAdded;
  }

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return 'Rs. ' + amount;
  }

  function updateButtons() {
    const list = getWishlist();
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      const handle = btn.getAttribute('data-handle');
      if (handle && list.includes(handle)) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }

  function updateBadges() {
    const count = getWishlist().length;

    // Header count bubble
    const headerCount = document.getElementById('header-wishlist-count');
    if (headerCount) {
      headerCount.textContent = count;
      headerCount.style.display = count > 0 ? 'flex' : 'none';
    }

    // Drawer count in header title
    const drawerCount = document.getElementById('wishlist-drawer-count');
    if (drawerCount) {
      drawerCount.textContent = count;
    }

    // Drawer footer clear button
    const footer = document.getElementById('wishlist-drawer-footer');
    if (footer) {
      footer.style.display = count > 0 ? 'block' : 'none';
    }

    // Mobile menu badge if present
    const mobileDrawerBadge = document.getElementById('drawer-wishlist-count');
    if (mobileDrawerBadge) {
      mobileDrawerBadge.textContent = count;
      mobileDrawerBadge.style.display = count > 0 ? 'inline-block' : 'none';
    }
  }

  function renderWishlistDrawer() {
    const container = document.getElementById('wishlist-drawer-items');
    if (!container) return;

    const list = getWishlist();
    if (list.length === 0) {
      container.innerHTML = `
        <div class="wishlist-empty">
          <svg class="wishlist-empty__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
          </svg>
          <h3 class="wishlist-empty__title">Your wishlist is empty</h3>
          <p class="wishlist-empty__desc">Browse our products and bookmark your favorite pieces to save them here.</p>
          <a href="/collections/all" class="wishlist-empty__btn" onclick="window.closeWishlistDrawer()">Explore Products</a>
        </div>
      `;
      return;
    }

    container.innerHTML = '<div style="padding: 40px 0; text-align: center; color: #6b7280; font-size: 1.4rem;">Loading wishlist items...</div>';

    const promises = list.map(handle =>
      fetch(`/products/${handle}.js`)
        .then(res => res.ok ? res.json() : null)
        .catch(() => null)
    );

    Promise.all(promises).then(products => {
      const valid = products.filter(p => p !== null);
      if (valid.length === 0) {
        container.innerHTML = `
          <div class="wishlist-empty">
            <h3 class="wishlist-empty__title">Your wishlist is empty</h3>
            <a href="/collections/all" class="wishlist-empty__btn" onclick="window.closeWishlistDrawer()">Explore Products</a>
          </div>
        `;
        return;
      }

      container.innerHTML = valid.map(product => {
        let imageSrc = '';
        if (product.featured_image) {
          imageSrc = product.featured_image;
        } else if (product.images && product.images.length > 0) {
          imageSrc = product.images[0];
        }
        if (imageSrc && imageSrc.startsWith('//')) {
          imageSrc = 'https:' + imageSrc;
        }

        const priceText = formatMoney(product.price);
        const hasCompare = product.compare_at_price > product.price;
        const compareText = hasCompare ? formatMoney(product.compare_at_price) : '';

        return `
          <div class="wishlist-item" data-handle="${product.handle}">
            <a href="${product.url}" class="wishlist-item__img-link">
              ${imageSrc ? `<img src="${imageSrc}" width="80" height="96" alt="${product.title.replace(/"/g, '&quot;')}" class="wishlist-item__img" loading="lazy">` : `<div style="display:flex;align-items:center;justify-content:center;height:100%;font-size:1.1rem;color:#888;">No Image</div>`}
            </a>
            <div class="wishlist-item__details">
              <a href="${product.url}" class="wishlist-item__title">${product.title}</a>
              <div class="wishlist-item__price-wrap">
                <span>${priceText}</span>
                ${hasCompare ? `<span class="wishlist-item__compare-price">${compareText}</span>` : ''}
              </div>
              <div class="wishlist-item__actions">
                <a href="${product.url}" class="wishlist-item__view-btn">View Product</a>
              </div>
            </div>
            <button type="button" class="wishlist-item__remove-btn" data-remove-handle="${product.handle}" aria-label="Remove item">
              &times;
            </button>
          </div>
        `;
      }).join('');
    });
  }

  function openWishlistDrawer() {
    const overlay = document.getElementById('wishlist-drawer-overlay');
    const drawer = document.getElementById('wishlist-drawer-panel');
    if (overlay && drawer) {
      overlay.classList.add('open');
      drawer.classList.add('open');
      document.body.classList.add('wishlist-open');
      renderWishlistDrawer();
    }
  }

  function closeWishlistDrawer() {
    const overlay = document.getElementById('wishlist-drawer-overlay');
    const drawer = document.getElementById('wishlist-drawer-panel');
    if (overlay && drawer) {
      overlay.classList.remove('open');
      drawer.classList.remove('open');
      document.body.classList.remove('wishlist-open');
      document.body.style.overflow = '';
    }
  }

  function updateAll() {
    updateBadges();
    updateButtons();
  }

  // Expose global methods
  window.openWishlistDrawer = openWishlistDrawer;
  window.closeWishlistDrawer = closeWishlistDrawer;
  window.toggleWishlist = toggleWishlist;
  window.getWishlist = getWishlist;

  // Event Listeners
  document.addEventListener('DOMContentLoaded', () => {
    document.body.classList.remove('wishlist-open');
    document.body.style.overflow = '';
    updateAll();

    // Open drawer button
    const openBtn = document.getElementById('header-wishlist-btn');
    if (openBtn) {
      openBtn.addEventListener('click', (e) => {
        e.preventDefault();
        openWishlistDrawer();
      });
    }

    // Close drawer buttons
    const closeBtn = document.getElementById('wishlist-drawer-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', closeWishlistDrawer);
    }
    const overlay = document.getElementById('wishlist-drawer-overlay');
    if (overlay) {
      overlay.addEventListener('click', closeWishlistDrawer);
    }

    // Clear all button
    const clearBtn = document.getElementById('wishlist-clear-all');
    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        saveWishlist([]);
        updateAll();
        renderWishlistDrawer();
        showToast('Wishlist cleared');
      });
    }

    // ESC key closes drawer
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeWishlistDrawer();
    });

    // Delegated clicks for bookmark toggles and removes
    document.addEventListener('click', (e) => {
      const wishlistBtn = e.target.closest('[data-wishlist-btn]');
      if (wishlistBtn) {
        e.preventDefault();
        e.stopPropagation();
        const handle = wishlistBtn.getAttribute('data-handle');
        if (handle) {
          toggleWishlist(handle);
        }
        return;
      }

      const removeBtn = e.target.closest('[data-remove-handle]');
      if (removeBtn) {
        e.preventDefault();
        const handle = removeBtn.getAttribute('data-remove-handle');
        if (handle) {
          let list = getWishlist().filter(h => h !== handle);
          saveWishlist(list);
          updateAll();
          renderWishlistDrawer();
          showToast('Removed from wishlist');
        }
      }
    });

    window.addEventListener('wishlist:changed', () => {
      updateAll();
    });
  });
})();
